module.exports = __webpack_public_path__ + "static/media/logo-white.1036d063.png";